import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=f72a9ada&scoped=true"
import script from "./TitleHeader.vue?vue&type=script&lang=ts"
export * from "./TitleHeader.vue?vue&type=script&lang=ts"
import style0 from "./TitleHeader.vue?vue&type=style&index=0&id=f72a9ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a9ada",
  null
  
)

export default component.exports